import { Reveal } from "@/components/Reveal";

const DEFAULT_BIO =
  "Victor Kwawukume is a Ghanaian-Canadian journalist, strategic communicator, author and public-interest advocate based in Toronto, Canada. He has more than two decades of experience in journalism, governance reporting, public policy and strategic communications.";

export default function Founder({ bio = DEFAULT_BIO }) {
  return (
    <section id="founder" data-testid="founder-section" className="border-y border-atlantic/10 bg-sand-dark py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 lg:grid-cols-12 lg:px-8">
        <Reveal className="lg:col-span-3">
          <div className="relative mx-auto max-w-[260px] lg:mx-0" data-testid="founder-photo">
            <div className="absolute -left-3 -top-3 h-full w-full border border-gold/60" aria-hidden="true" />
            <img
              src="/images/victor-kwawukume.png"
              alt="Victor Kwawukume, Founder and Editor-in-Chief, Atlantic Bridge Institute."
              loading="lazy"
              className="relative aspect-[4/5] w-full object-cover"
            />
          </div>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-8 lg:col-start-5">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-ocean">Founder</p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight text-atlantic sm:text-4xl">Victor Kwawukume</h2>
          <p className="mt-2 text-sm font-semibold uppercase tracking-[0.18em] text-gold">Founder and Editor-in-Chief</p>
          <p className="mt-7 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
            {bio}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
